"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PercentageFormat = PercentageFormat;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

function PercentageFormat(params) {
  return !(0, _isNil["default"])(params.value) ? "".concat(params.value, "%") : '';
}